import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {ResponseApi} from "../BaseApi";
import {ZoneDetailChildV1} from "./EmployeeZonesApi";

const employeeProviderSlice = createSlice({
    name: 'employeeZones',
    initialState: {
        getListFatherZones: [],
        getListStatusZone: [],
        createFatherZone: null,
        createChildZone: [],
        zoneDetailFatherAndChild: [],
        zoneDetailChildV1: [],
        zoneDetailChild: [],
        zoneDetailAuthorizedEmployee: [],
        zoneDetailAuthorizedEmployeeNoPagination: [],
        zoneDetailListDevice: [],
        createCommonAreaZone: null,
        updateZone: null,
        updateCommonAreaZone: null,
        getAccessType: [],
        getDeviceType: [],
        createDeviceZone: null,
        deleteZoneUser: '',
        getListZoneMap: [],
        createZonePlane: {},
        uploadImgZonePlane: null,
        deleteImgZonePlane: null,
        setZoneImageCoordinate: null,
        getZoneDevicesLists: [],
        getAllZoneUser: [],
        getDeviceZone: [],
        getDeviceSmartlock: [],
    },
    reducers: {
        ClearGetListZoneMap: (state, action) => {
            state.getListZoneMap = [];
        },
        clearZoneDetailFatherAndChild: (state, action) => {
            state.zoneDetailFatherAndChild = [];
        },
        clearZoneDetailChildV1: (state, action) => {
            state.zoneDetailChildV1 = [];
        },
    },
    extraReducers: {
        'employeeZones/getListFatherZones/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getListFatherZones = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/getListStatusZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getListStatusZone = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/createFatherZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
                state.createFatherZone = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/createChildZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
                state.createChildZone = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/zoneDetailFatherAndChild/fulfilled': (state, action) => {
            state.zoneDetailFatherAndChild = ResponseApi(action.payload);
        },
        'employeeZones/zoneDetailChild/fulfilled': (state, action) => {
            state.zoneDetailChild = ResponseApi(action.payload);
        },
        'employeeZones/zoneDetailChildV1/fulfilled': (state, action) => {
            state.zoneDetailChildV1 = ResponseApi(action.payload);
        },
        'employeeZones/zoneDetailAuthorizedEmployee/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.zoneDetailAuthorizedEmployee = data?.data;
            } else if (status >= 400 && status < 500) {
                // toast("Fail to Fetch Zone Detail Authorized Employee")
            }
        },
        'employeeZones/zoneDetailAuthorizedEmployeeNoPagination/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.zoneDetailAuthorizedEmployeeNoPagination = data?.data;
            } else if (status >= 400 && status < 500) {
                // toast("Fail to Fetch Zone Detail Authorized Employee")
            }
        },

        'employeeZones/zoneDetailListDevice/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.zoneDetailListDevice = data?.data;
            } else if (status >= 400 && status < 500) {
                // toast("Fail to Fetch Zone Detail List Device")
            }
        },
        'employeeZones/updateZone/fulfilled': (state, action) => {
            state.createEmployeeDoc = ResponseApi(action.payload);
        },
        'employeeZones/createCommonAreaZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_updated_successfully'));
                state.createCommonAreaZone = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/updateCommonAreaZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.updateCommonAreaZone = data?.data;
            } else if (status >= 400 && status < 500) {
            }
        },

        'employeeZones/getAccessType/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAccessType = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/getDeviceType/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getDeviceType = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/createDeviceZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
                state.createDeviceZone = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/createDeviceSmartlock/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/getDeviceZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getDeviceZone = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/getDeviceSmartlock/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getDeviceSmartlock = data?.data;
            } else if (status >= 400 && status < 500) {
                // toast("Fail to get smart lock")
            }
        },

        'employeeZones/deleteDevice/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_deleted_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/updateDeviceZone/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_updated_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/updateDeviceSmartlock/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(data.message);
                // state.updateDeviceSmartlock
                //     = data?.data
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },

        'employeeZones/deleteZoneUser/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_deleted_successfully'));
                state.deleteZoneUser = data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/getListZoneMap/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getListZoneMap = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/createZonePlane/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_created_successfully'));
                state.createZonePlane = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/uploadImgZonePlane/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_updated_successfully'));
                state.uploadImgZonePlane = data;
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/deleteImgZonePlane/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_deleted_successfully'));
                state.deleteImgZonePlane = data;
                window.location.reload();
            } else if (status >= 400 && status < 500) {
                toast.error('something_went_wrong_2');
            }
        },
        'employeeZones/setZoneImageCoordinate/fulfilled': (state, action) => {
            state.setZoneImageCoordinate = ResponseApi(action.payload)
        },
        'employeeZones/getZoneDevicesLists/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getZoneDevicesLists = data?.data;
            } else if (status >= 400 && status < 500) {
                // toast("Fail to fetch Zone Devices Lists")
            }
        },
    },
});

export const { ClearGetListZoneMap } = employeeProviderSlice.actions;

export const { clearZoneDetailFatherAndChild } = employeeProviderSlice.actions;

export default employeeProviderSlice.reducer;
